import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { TicketWatcher } from "@app2/type-defs/ticket/ticket-types";

@Component({
    selector: "ticket-watcher-select",
    template: `
        <label>{{ "NEW_WATCHER" | localize }}</label>
        <div class="new-watcher-container">
            <person-picker [selectedId]="newWatcher.personId"
                           [placeholder]="'SELECT_USERS' | localize"
                           [excludedUsers]="excludedUsers"
                           (selectedIdChange)="onPersonSelected($event)">
            </person-picker>
            <i *ngIf="isPersonSelected || hideSelectorOnReset"
               (click)="resetWatcher()"
               class="fal fa-times reset-watcher alert"
               test-id="reset-watcher-button"></i>
        </div>
        <div *ngIf="isPersonSelected" class="state-container">
            <a (click)="toggleWatcherType()" test-id="toggle-state-notifications">
                <i [matTooltip]="'WATCHERS_NOTIFICATIONS_TOOLTIP' | localize"
                   class="fa term-label"
                   [ngClass]="newWatcher.type === 'state' ? 'fa-toggle-large-on primary' : 'fa-toggle-large-off secondary'"></i>
                {{ "WATCHER_NOTIFICATIONS_STATE" | localize }}
            </a>
        </div>
    `,
    styles: [`
      .new-watcher-container {
        display: flex;
      }

      .state-container {
        display: flex;
        margin-bottom: 1rem;
      }

      .reset-watcher {
        margin-left: 0.5rem;
        padding: 0.5rem;
        cursor: pointer;
        font-size: 1rem;
      }
    `],
})
export class TicketWatcherSelectComponent implements OnChanges {
    @Input() currentWatchers: TicketWatcher[];
    // All notifications is the default
    @Input() watcher: TicketWatcher = { personId: null, type: "all" };
    @Input() hideSelectorOnReset: boolean = false;
    @Output() watcherChange = new EventEmitter<TicketWatcher>();
    @Output() clearWatcher = new EventEmitter<void>();

    newWatcher: TicketWatcher;
    excludedUsers: uuid[];
    isPersonSelected: boolean;

    constructor() {
    }

    ngOnChanges() {
        this.newWatcher = {
            personId: null,
            type: "all",
            ...this.watcher,
        };

        if (this.watcher) {
            this.isPersonSelected = !!this.watcher.personId;
        }

        this.excludedUsers = this.currentWatchers.map(watcher => watcher.personId);
    }

    resetWatcher() {
        this.isPersonSelected = false;
        this.newWatcher = {
            personId: null,
            type: "all",
        };
        this.watcherChange.emit(this.newWatcher);
        this.clearWatcher.emit();
    }

    toggleWatcherType() {
        this.newWatcher.type = this.newWatcher.type === "state" ? "all" : "state";
        this.watcherChange.emit(this.newWatcher);
    }

    onPersonSelected(personId: uuid) {
        this.isPersonSelected = true;
        this.newWatcher.personId = personId;
        this.newWatcher.type = "all";
        this.watcherChange.emit(this.newWatcher);
    }
}
